module.exports = __webpack_public_path__ + "static/media/clockwise.e29b6df2.svg";